import React, { lazy, Suspense } from "react";

const Create = lazy(() => import("views/adminViews/Create.js"));
const UsersList = lazy(() => import("views/adminViews/UsersList.js"));
const User = lazy(() => import("views/adminViews/User.js"));
const Password = lazy(() => import("views/adminViews/ChangePassword.js"));
const TransactionList = lazy(() => import("views/adminViews/TransactionList.js"));
const Transaction = lazy(() => import("views/adminViews/Transaction.js"));
const CreateTransaction = lazy(() => import("views/adminViews/CreateTransaction.js"));
const ViewTransactionList = lazy(() => import("views/adminViews/ViewTransactionList.js"));
const Notification = lazy(() => import("views/adminViews/Notification"));
const Wallets = lazy(() => import("views/adminViews/Wallets"));
const Gift = lazy(() => import("views/adminViews/Gift"));
const Chat = lazy(() => import("views/adminViews/Chat"));
const VirtualCards = lazy(() => import("views/adminViews/VirtualCards"));

const Lazy = ({ children }) => (
  <Suspense fallback={
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
      <div style={{
        width: 40, height: 40,
        border: "3px solid var(--border)",
        borderTopColor: "var(--accent)",
        borderRadius: "50%",
        animation: "spin 0.7s linear infinite",
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  }>
    {children}
  </Suspense>
);

var adminRoutes = [
  { path: "/create", name: "Create user", icon: "nc-icon nc-chart-bar-32", component: <Lazy><Create /></Lazy>, layout: "/admin" },
  { path: "/users", name: "view all user", icon: "nc-icon nc-tile-56", component: <Lazy><UsersList /></Lazy>, layout: "/admin" },
  { path: "/transactions", name: "transactions", icon: "nc-icon nc-tile-56", component: <Lazy><TransactionList /></Lazy>, layout: "/admin" },
  { path: "/wallets", name: "wallets", icon: "nc-icon nc-app", component: <Lazy><Wallets /></Lazy>, layout: "/admin" },
  { path: "/gifts", name: "Gift cards", icon: "nc-icon nc-app", component: <Lazy><Gift /></Lazy>, layout: "/admin" },
  { path: "/users/:id", name: "view 1", icon: "nc-icon nc-tile-56", component: <Lazy><User /></Lazy>, layout: "/admin", hidden: true },
  { path: "/users/password/:id", name: "view 2", icon: "nc-icon nc-tile-56", component: <Lazy><Password /></Lazy>, layout: "/admin", hidden: true },
  { path: "/transaction/:id", name: "view 3", icon: "nc-icon nc-chart-bar-32", component: <Lazy><CreateTransaction /></Lazy>, layout: "/admin", hidden: true },
  { path: "/transaction/:id/view", name: "view 4", icon: "nc-icon nc-tile-56", component: <Lazy><ViewTransactionList /></Lazy>, layout: "/admin", hidden: true },
  { path: "/transaction/:id/edit", name: "view 5", icon: "nc-icon nc-tile-56", component: <Lazy><Transaction /></Lazy>, layout: "/admin", hidden: true },
  { path: "/send-notification/:id", name: "view 6", icon: "nc-icon nc-tile-56", component: <Lazy><Notification /></Lazy>, layout: "/admin", hidden: true },
  { path: "/chat", name: "Support Chat", icon: "nc-icon nc-chat-33", component: <Lazy><Chat /></Lazy>, layout: "/admin" },
  { path: "/virtual-cards", name: "Virtual Cards", icon: "nc-icon nc-credit-card", component: <Lazy><VirtualCards /></Lazy>, layout: "/admin" },
];

export default adminRoutes;